import { HsTableServiceSymbol } from '@/services/HsTableService';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { useFormatRefiner } from './useFormatRefiner';
import _ from 'lodash';
import { updateViewDataReadStatusApi } from '@cores/apis/workspace_api/viewData';
import { useReloadTableData } from '@/presentation/pages/detail/basic/hooks/useReloadTableData';
import { injectService } from '@/inversify.config';
import { DetailServiceSymbol } from '@/services/DetailService';
import { useFolderSetting } from '@/presentation/pages/workspace-detail/composables/use-folder-setting';
const hsTableService = injectService(HsTableServiceSymbol);
export function useUpdateReadStatus() {
    const { currentSort } = useFolderSetting();
    return {
        updateReadStatus(type) {
            const detailService = injectService(DetailServiceSymbol);
            const pageSelectorService = injectService(PageSelectorServiceSymbol);
            const { folderId, viewData, viewDataKeyConfig } = detailService;
            const { mode, finalIds, rangeFrom, rangeTo } = pageSelectorService;
            const { rowIdKey } = viewDataKeyConfig;
            return updateViewDataReadStatusApi({
                folder_id: folderId,
                read_status: type === 'read',
                select_mode: mode,
                doc_ids: finalIds,
                refiner: useFormatRefiner(),
                start: rangeFrom,
                end: rangeTo,
                sort: currentSort.value,
                data_type: detailService.viewDataType,
            }).then((data) => {
                if (data.async) {
                    return data;
                }
                const reads = [];
                const unreads = [];
                _.forEach(data.read_status, (item) => {
                    item.read_status ? reads.push(item.doc_id) : unreads.push(item.doc_id);
                });
                // @ts-ignore
                _.forEach(viewData.details, (rowData) => {
                    const id = rowData[rowIdKey];
                    if (reads.includes(id)) {
                        rowData.READ_STATUS = true;
                    }
                    else if (unreads.includes(id)) {
                        rowData.READ_STATUS = false;
                    }
                });
                if (_.get(hsTableService, 'hsSettings.data')) {
                    _.forEach(hsTableService.hsSettings.data, (rowData) => {
                        const id = rowData[rowIdKey];
                        if (reads.includes(id)) {
                            rowData.READ_STATUS = true;
                        }
                        else if (unreads.includes(id)) {
                            rowData.READ_STATUS = false;
                        }
                    });
                    useReloadTableData();
                }
            }).catch((error) => {
                console.log(error);
            });
        },
    };
}
